import { forwardRef } from "react";
import { Switch as RNSwitch, SwitchProps } from "react-native";

export const Switch = forwardRef<RNSwitch, SwitchProps>(function Switch(
  { ...props },
  ref
) {
  return <RNSwitch ref={ref} {...props} />;
});
